<ng-container [ngSwitch]="type">
  <div *ngSwitchCase="'gigastor'" class="data-source-list">
    <div class="data-source-list__header">
      <div class="data-source-list__header__cell span-2-col">Appliance name</div>
      <div class="data-source-list__header__cell action"></div>
    </div>
    <div class="data-source-list__body" *ngFor="let item of dataSource">
      <div class="data-source-list__body__cell bolder-text--medium span-2-col">{{item.name}}</div>
      <div class="data-source-list__body__cell action">
        <div class="action-btn" (click)="removeItem(item)">
          <mat-icon class="action-btn__icon">highlight_off</mat-icon>
        </div>
      </div>
    </div>
  </div>

  <div *ngSwitchCase="'gigaflow'" class="data-source-list">
    <div class="data-source-list__header">
      <div class="data-source-list__header__cell span-2-col">Device name</div>
      <div class="data-source-list__header__cell action"></div>
    </div>
    <div class="data-source-list__body" *ngFor="let item of dataSource">
      <div class="data-source-list__body__cell bolder-text--medium span-2-col">{{item.name}}</div>
      <div class="data-source-list__body__cell action">
        <div class="action-btn" (click)="removeItem(item)">
          <mat-icon class="action-btn__icon">highlight_off</mat-icon>
        </div>
      </div>
    </div>
  </div>

  <div *ngSwitchCase="'gigatest'" class="data-source-list">
    <div class="data-source-list__header">
      <div class="data-source-list__header__cell">Test name</div>
      <div class="data-source-list__header__cell">Location</div>
      <div class="data-source-list__header__cell action"></div>
    </div>
    <div class="data-source-list__body" *ngFor="let item of dataSource">
      <div class="data-source-list__body__cell bolder-text--medium">{{item.name}}</div>
      <div class="data-source-list__body__cell">{{item.location}}</div>
      <div class="data-source-list__body__cell action">
        <div class="action-btn" (click)="removeItem(item)">
          <mat-icon class="action-btn__icon">highlight_off</mat-icon>
        </div>
      </div>
    </div>
  </div>

  <div *ngSwitchCase="'success-result'" class="data-source-list">
    <div class="data-source-list__header">
      <div class="data-source-list__header__cell">Site</div>
      <div class="data-source-list__header__cell"></div>
    </div>
    <div class="data-source-list__body with-success-col" *ngFor="let item of dataSource">
      <div class="data-source-list__body__cell bolder-text--medium">
        <div>{{item.name}}</div>
        <div *ngIf="item.location && item.location.country">
          &ndash; {{item.location?.city}}, {{item.location?.country}}
        </div>
      </div>

      <div class="data-source-list__body__cell success-color">success</div>
    </div>
  </div>

  <div *ngSwitchCase="'error-result'" class="data-source-list">
    <div class="data-source-list__header">
      <div class="data-source-list__header__cell">Site</div>
      <div class="data-source-list__header__cell two-last-span-cell">Error</div>
    </div>
    <div class="data-source-list__body" *ngFor="let item of dataSource">
      <div class="data-source-list__body__cell bolder-text--medium">{{item.siteName}}</div>
      <div class="data-source-list__body__cell error-cell two-last-span-cell">{{item.error}}</div>
    </div>
  </div>
</ng-container>
